import axios from 'axios'

export const nic = {
    namespaced: true,
    state: () => ({
        v_nics: [],
        v_loading_nic:{
          status:false,
          message:''
        },
    }),
    mutations: {
       
        V_NICS(state, data_nics ) {
          state.v_nics = data_nics
        
        },
        
    }, 
    actions:{
        v_actions_nics({ commit,rootState}){
          
          rootState.v_loading = true;


          let config = {
            headers: {
            'Authorization': 'Bearer ' +  rootState.login.v_user.accessToken,
            'Accept':'application/json'
              }
          }
          return axios.get(rootState.v_url_global+'/nics',config)
            .then(response => {
              commit('V_NICS',response.data)
              rootState.v_loading = false;
            })
            .catch(e =>{
              e
              rootState.v_loading = false;
            }
              

            );
        }
      },

}